<template>
  <div>
    <div class="d-flex justify-content-end py-1">
      <base-link-with-icon
        small
        @click="editor = true"
      >
        Add Note
      </base-link-with-icon>
    </div>
    <notification-editor
      v-if="editor"
      @cancel="editor = false"
      @post="$emit('add-note', $event); editor = false"
    />
    <base-loading :show="loading" />
    <div v-if="!loading && notes.length === 0">
      <empty title="No notes for this client" />
    </div>
    <notification-item
      v-for="(note, index) in notes"
      :key="`information_note_${index}`"
      :title="note.author_user.first_name + ' ' + note.author_user.last_name"
      :date="note.date"
      :message="note.text"
    />
  </div>
</template>
<script>
import NotificationEditor from '@/components/Widgets/Notifications/NotificationEditor';
import NotificationItem from '@/components/Widgets/Notifications/NotificationItem';

export default {
  name: 'Notes',
  components: {
    NotificationItem,
    NotificationEditor,
  },
  props: {
    notes: {
      type: Array,
      default: () => {
        // eslint-disable-next-line no-unused-expressions
        [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      editor: false,
    };
  },
};
</script>
